import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ContactList from "./ContactList";
import { ModalPickerProps } from "../props";
import { RemovableContactLabel } from "components/Removables/RemovableContact";
import ContactNewModal from "contact/new/App";

interface Props extends ModalPickerProps<server.dto.ContactSmallV2> {
  title?: string;
  initialKeyword?: string;
  excludeKeys?: number[];
  buttonLabel?: string;
}

const ContactModalPicker = (props: Props) => {
  const [displayNewContact, setDisplayNewContact] = React.useState(false);

  return <>
    {displayNewContact && <ContactNewModal
      onClose={() => setDisplayNewContact(false)}
      onCreated={(contact) => {
        setDisplayNewContact(false);
        props.onChange(contact);
      }}
    />}
    <ModalPickerWithChooseButton
      onNewClicked={() => setDisplayNewContact(true)}
      buttonLabel={props.buttonLabel ?? RESX.Buttons.btnSelect}
      modalTitle={props.title ?? RESX.Contact.Contacts}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ContactList
        initialKeyword={props.initialKeyword}
        excludeKeys={props.excludeKeys}
        onItemSelected={(contact) => {
          closeModal();
          props.onChange(contact);
        }}
      />}
      renderRemovable={(props) => <RemovableContactLabel {...props} />}

      {...props}
    />
  </>
};

export default ContactModalPicker;